export const getSectionClassNames = (color) => {
  const safeColor = (color || 'white').toLowerCase();
  return `section-${safeColor}${
    safeColor !== 'white' && safeColor !== 'offset' ? ' section-padded' : ''
  }`;
};

export const getBackgroundColorClassName = (color) => {
  const safeColor = (color || 'white').toLowerCase();
  return `bg-${safeColor}`;
};

export default getSectionClassNames;
